<template>
  <div class="dialog unit-module">
    <div class="content">
      <div
        class="close"
        @click="onClose"
        ></div>
      <div class="title">{{course.name}}</div>
      <div class="main">
        <div class="left">
          <div class="title">选择单元</div>
          <div class="unit-list">
            <div
              class="unit"
              :class="{'active': currentUnit.id === unit.id}"
              @click="selectUnit(unit)"
              v-for="unit in unitList"
              :key="unit.id">
              <div>
                <span>{{unit.name}}</span>
                <span class="experience" v-if="unit.isExperience">快速体验</span>
              </div>
              <div
                class="status"
                :class="{ 'finished': unit.status }"
                size="mini"
                effect="dark">
                {{unit.status ? '已完成' : '未完成'}}
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="title">{{currentUnit.name}}</div>
          <div class="module-list">
            <div
              class="module"
              v-for="module in moduleList"
              :key="module.id">
              <div class="module-left">{{module.name}}</div>
              <div class="module-right">
                <el-progress
                  :text-inside="true"
                  status="warning"
                  class="progress"
                  :stroke-width="15"
                  :percentage="module.progress">
                </el-progress>
                <div
                  :class="{'disable': !module.isOpen}"
                  class="btn btn-blue-square"
                  @click="start(module, module.id, 'view', module.isOpen)">
                  新学
                </div>
                <div
                  :class="{'disable': !module.reviewIsOpen}"
                  class="btn btn-orange-square"
                  v-if="module.reviewId"
                  @click="start(module, module.reviewId, 'review', module.reviewIsOpen)">
                  复习
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <van-dialog
      ref="notAvailable"
      append-to-boby
      moda-aAppend-today
    >
      <div class="title" slot="title">体验结束</div>
      <div class="not-available">
        <p>你表现的太好啦！</p>
        <p>现在停止学习太可惜啦，快联系老师为您开卡继续学习吧！</p>
        <p>使用期间您有任何疑问，请联系相关运营人员。</p>
        <el-button
          @click="closeNotAvailable(item)"
        >
          知道啦
        </el-button>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Progress } from 'element-ui';
import utils from '@/services/utils';
import api from '@/api/graphql/course';
import VanDialog from '@/components/common/Dialog.vue';

export default {
  props: {
    course: {
      type: Object,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ElProgress: Progress,
    VanDialog,
  },
  watch: {
    show() {
      if (this.course.id && this.show) {
        this.fetchUnitList(this.course.id);
      }
    },
  },
  data() {
    return {
      unitList: [],
      moduleList: [],
      currentUnit: {},
    };
  },
  methods: {
    onClose() {
      this.$emit('close', {
        scene: 'selectCourse',
      });
    },
    fetchModuleList(unit) {
      api.getCourseModulelList({
        unitId: unit.id,
      }).then(({ courseModuleList }) => {
        this.moduleList = courseModuleList;
        this.fetchUnitList(this.course.id, false);
      });
    },
    fetchUnitList(courseId, isUpdate = true) {
      this.currentCourseId = courseId;
      api.getCourseUnitList({
        courseId,
      }).then(({ courseUnitList }) => {
        const [first] = courseUnitList;

        const currentUnit = isUpdate && first ? first : this.currentUnit;

        this.unitList = courseUnitList;

        if (currentUnit.id && isUpdate) {
          this.selectUnit(currentUnit);
        }
      });
    },
    closeNotAvailable() {
      this.$refs.notAvailable.close();
    },
    selectUnit(unit) {
      if (!unit.isAvailable) {
        this.$refs.notAvailable.open();
        return;
      }
      this.currentUnit = unit;
      this.fetchModuleList(unit);
    },
    start(module, id, type, isOpen) {
      if (!isOpen) {
        utils.error('请先完成上一篇文章的“新学”');
        return;
      }
      this.$emit('change', {
        scene: 'quizzesDialog',
        params: {
          module: {
            ...module,
            id,
          },
          type,
          unit: this.currentUnit,
        },
      });
    },
  },
};
</script>

<style lang="scss">
  @import '@/styles/variables.scss';
  .not-available {
    text-align: center;
    color: $primary-light;
    font-size: $font-size-lg;
    font-weight: bold;
    button {
      background: $primary-light;
      color: #fff;
      border-radius: 8px;
    }
  }
</style>

<style lang="scss" scoped>
  @import "@/styles/common/dialog.scss";
  @import '@/styles/variables.scss';
  .unit-module {
    width: 80vw;
    height: 90vh;
    .content {
      display: flex;
      flex-direction: column;
    }
    .main {
      padding: 8vh 4vh;
      flex: 1;
      display: flex;
      justify-content: space-between;
      overflow: hidden;
      border-radius: 10px;
      background: url('https://vanthink.oss-cn-qingdao.aliyuncs.com/41101b79168886824d5c05030d02a679.png')
        no-repeat center center / cover;
      .title {
        position: absolute;
        top: 0;
        left: 0;
        padding: 10px 20px;
        background: $primary;
        color: #fff;
        border-radius: 10px 10px 0 0;
        transform: translateY(-100%);
      }
      .left {
        position: relative;
        width: 40%;
        padding: 5px;
        background: #f1f6f9;
        border-radius: 0 10px 10px 0;
        .unit-list {
          height: 100%;
          border-radius: 0 10px 10px 0;
          overflow-y: auto;
          .unit {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 2vh 20px;
            color: #333;
            text-align: center;
            font-size: 2vh;
            font-weight: 500;
            cursor: pointer;
            &.active {
              color: #fff;
              background: #8185ed;
              .status {
                color: #fff;
              }
            }
            .experience {
              background-color: #e9f7fe;
              color: #4190f7;
              font-size: 12px;
              padding: 2px;
              border-radius: 8px;
              border: 1px solid #4190f7;
              margin-left: 5px;
            }
            .status {
              color: $light;
            }
            .finished {
              color: $primary;
            }
          }
        }
      }
      .right {
        position: relative;
        width: 55%;
        color: #18435C;
        background: #fff;
        border-radius: 0 10px 10px 0;
        .module-list {
          box-sizing: border-box;
          height: 100%;
          padding: 0 20px;
          overflow-y: auto;
          .module {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 2vh 0;
            color: #333;
            text-align: center;
            font-size: 2vh;
            font-weight: 500;
            border-bottom: 1px solid #eeeeee;
            cursor: pointer;
            .module-right {
              display: flex;
              align-items: center;
              .progress {
                margin-right: 20px;
                width: 10vw;
              }
              .disable {
                filter: grayscale(100%);
              }
              .btn:last-child {
                margin-left: 10px;
              }
            }
          }
        }
      }
    }
  }
</style>
